import React from 'react';
import { iFileText, iHome, iShoppingCart } from '@hover/icons';
import HomePageEstimates from '../assets/videos/home_page_estimates.mp4';
import HomePageMeasurements from '../assets/videos/home_page_measurement.mp4';
import HomePageOrdering from '../assets/videos/home_page_ordering.mp4';
import HomePageVisualization from '../assets/videos/home_page_visualization.mp4';
import MeasureIcon from '../assets/svgs/MeasureIcon';
import MeasureIconActive from '../assets/svgs/MeasureIconActive';
import { IHomePageTabs } from '../interfaces/IHomePageTabs';

const ListData: IHomePageTabs[] = [
  {
    id: 0,
    title: 'Spot-ON Measurements',
    body: 'Turn photos from your phone into fast and accurate measurements that save time and money.',
    svgIcon: MeasureIcon,
    svgIconActive: MeasureIconActive,
    renderVideo(props: any) {
      return <video src={HomePageMeasurements} muted {...props} playsInline />;
    },
  },
  {
    id: 1,
    title: 'Visualize In 3d',
    body: 'Collaborative 3D models let you visualize your project before you get started.',
    icon: iHome,
    renderVideo(props: any) {
      return <video src={HomePageVisualization} muted {...props} playsInline />;
    },
  },
  {
    id: 2,
    title: 'BETTER ESTIMATES',
    body: 'Faster and more accurate measurements give you faster and more accurate estimates.',
    icon: iFileText,
    renderVideo(props: any) {
      return <video src={HomePageEstimates} muted {...props} playsInline />;
    },
  },
  {
    id: 3,
    title: 'Order Directly',
    body: 'Seamlessly order exactly the right amount of materials for every project right inside the app.',
    icon: iShoppingCart,
    renderVideo(props: any) {
      return <video src={HomePageOrdering} muted {...props} playsInline />;
    },
  },
];

export default ListData;
